<div class="container mt-4">

  <div class="row mb-3">
    <div class="col-12">
      <h1>
        Cookie policy
      </h1>
    </div>
  </div>

  <div class="row mb-3">
    <div class="col-12">

      <h4 class="my-3">
        Cookies and how they benefit you
      </h4>

      <p>
        The Identicare website uses cookies, as almost all websites do, to help provide you with the best experience we can. Cookies are small text files that are placed on your computer or smartphone when you browse websites.
      </p>
      <p>
        Our cookies help us:
      </p>
      <ul>
        <li>
          Make the Identicare website work as you'd expect
        </li>
        <li>
          Remember your settings during and between visits
        </li>
        <li>
          Improve the speed/security of the site
        </li>
        <li>
          Continuously improve our website for you
        </li>
      </ul>
      <p>
        Cookies used within our websites are as follows:
      </p>

      <table class="table table-striped table-inverse table-responsive">
        <thead class="thead-inverse">
          <tr>
            <th>
              Cookie
            </th>
            <th>
              Purpose
            </th>
            <th>
              Expires
            </th>
          </tr>
          </thead>
          <tbody>
            <tr>
              <td scope="row">
                Session
              </td>
              <td>
                They enable the maintenance, functionality and flow of your session
              </td>
              <td>
                100 days after you've logged in. If you logout, no cookies will be stored.
              </td>
            </tr>
            <tr>
              <td scope="row">
                Personalisation
              </td>
              <td>
                They allow the website to remember logged in users and their preferences. This will include whether the person has accepted the cookie policy and tracking
              </td>
              <td>
                1 year.
              </td>
            </tr>
            <tr>
              <td scope="row">
                Google Analytics
              </td>
              <td>
                These cookies are used to collect information about how visitors use our site, which we use to help improve it. The cookies collect information in an anonymous form, including the number of visitors to the site, where visitors have come to the site from and the pages they visited.<br>
                <a href="http://www.google.co.uk/intl/en/analytics/privacyoverview.html" target="_blank">Click here for an overview of privacy at Google</a>
              </td>
              <td>
                2 years.
              </td>
            </tr>
          </tbody>
      </table>

      <p>
        Most web browsers allow control of cookies through the browser settings. To find out more about cookies, including how to see what cookies have been set and how to manage and delete them, visit <a href="http://www.allaboutcookies.org/" target="_blank">www.allaboutcookies.org</a>.
      </p>
      <p>
        To opt out of being tracked by Google Analytics across all websites visit <a href="http://tools.google.com/dlpage/gaoptout" target="_blank">http://tools.google.com/dlpage/gaoptout</a>.
      </p>

      <h4 class="my-3">
        Changes to this cookie policy
      </h4>

      <p>
        We keep our Cookies Policy under regular review. If we do update our Cookies
        Policy, you will be notified when you next visit our website and you will be able to
        view the new Cookies Policy. You can also revisit this page if you wish to keep
        yourself informed.
      </p>

      <h4 class="my-3">
        How to contact us
      </h4>

      <p>
        Information about our privacy statement can be requested by contacting us via e-
        mail at privacy&#64;identibase.co.uk or by writing to Identicare Ltd, Moorside, 
        Monks Cross Drive, Huntington, York, YO32 9LB.
      </p>

      <p>
        <a routerLink="/privacy">Our Privacy Policy</a> also provides further information
        about how we protect and use your information when using our website. You should
        read our Privacy Policy alongside this Cookies Policy.
      </p>

      <div class="mt-5">
        Last updated 15/04/2021
      </div>
    </div>
  </div>

</div>
